import { render, staticRenderFns } from "./DeclarationElement.vue?vue&type=template&id=0eeca60e&scoped=true"
import script from "./DeclarationElement.vue?vue&type=script&lang=ts"
export * from "./DeclarationElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeca60e",
  null
  
)

export default component.exports